import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  CardHeader,
  Nav,
  Row,
  Spinner,
  NavLink,
} from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  gAPI_Ingetration,
  API_Ingetration,
  gAPI_Property_List_By_Group,
  gAPI_Stripe_Connection,
  dAPI_Delete_Ingetration,
  postAPI_TrackEvent,
  gAPI_Site_Settings,
  gAPI_Internal_Property_By_Id,
} from '../../../../../constants/APIs';
import { faSalesforce, faOpera } from '@fortawesome/free-brands-svg-icons';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PhoneIntegration from './PhoneIntegration';
import GoogleBuisnessIntegration from './GoogleBuisnessIntegration';
import RevinateIntegration from './RevinateIntegration';
import RevinateIntegrationThumb from './RevinateIntegrationThumb';
import StripeIntregation from './StripeIntregation';
import OpenAccount from './OpenAccount';
import ShowMessage from './ShowMessage';

import RevinateLogo from '../../../../../assets/Revinate-logo.png';

import FlexiPass from '../../../../../assets/flexi_pass.jpg';

import RMSLogo from '../../../../../assets/rms.ico';
import SiteMinderLogo from '../../../../../assets/siteminder.svg';
import AmadeusLogo from '../../../../../assets/amadeus_logo.png';
import Myma_Logo from '../../../../../assets/myma_logo.png';
import Mews_Logo from '../../../../../assets/mews_logo.jpg';
import Genesys_Cloud_Logo from '../../../../../assets/genesys_cloud_logo.png';
import BookingEngine from '../../../../../assets/bookingengine.png';
import RestApiLogo from '../../../../../assets/rest_api_icon.png';
import Oracle_logo from '../../../../../assets/Oracle_logo.png';
import Zendesk_logo from '../../../../../assets/zendesk_logo.png';
import SHR_Logo from '../../../../../assets/SHR_Logo.png';
import WebRTC_logo from '../../../../../assets/webrtc.jpg';
import Azure_logo from '../../../../../assets/Azure_logo.png';

import RMSIntegration from './RMSIntegration';
import SiteminderIntegration from './SiteminderIntegration';
import AmadeusIntegration from './AmadeusIntegration';
import AmadeusIntegrationThumb from './AmadeusIntegrationThumb';
import BookingEngineUrlIntegration from './BookingEngineUrlIntegration';
import BookingEngineUrlIntegrationThumb from './BookingEngineUrlIntegrationThumb';
import AddServiceStandalonePageIntegration from './ServiceStandalone/AddServiceStandalonePageIntegration';
import StandalonePageIntregationThumb from './ServiceStandalone/StandalonePageIntregationThumb';
import AddEmbedPageIntegration from './EmbedPage/AddEmbedPageIntegration';
import ShowWarningMessage from './ShowWarningMessage';
import SalesforceIntegrationThumb from './SalesforceIntegrationThumb';
import SalesforceIntegration from './SalesforceIntegration';
import AddStandaloneGuestServicePageIntegration from './GuestServiceStandalone/AddStandaloneGuestServicePageIntegration';

import CloudBeds_Logo from '../images/cloudBeds_logo.png';

import OracleOperaIntegration from './OracleOpera/OracleOperaIntegration';
import OracleOperaIntegrationThumb from './OracleOpera/OracleOperaIntegrationThumb';
import AddHelpCenterIntegration from './HelpCenter/AddHelpCenterIntegration';

import GoogleAnalyticsThumb from './GoogleAnalyticsThumb';
import GoogleAnalyticsIntegration from './GoogleAnalyticsIntegration';
import Analytics_Logo from './../../../../../assets/google_analytics.png';
import AddHelpCenterGroupIntegration from './HelpCenterGroup/AddHelpCenterGroupIntegration';

import SpaceStandalonePageIntregationThumb from './SpaceStandalone/SpaceStandalonePageIntegrationThumb';
import AddSpaceStandAlonePageIntegration from './SpaceStandalone/AddSpaceStandalonePageIntegration';
import PhoneSuiteIntegration from './PhoneSuite/PhoneSuiteIntegration';

import WebRTCIntegration from './WebRTC/WebRTCIntegration';
import WebRTCIntegrationThumb from './WebRTC/WebRTCIntegrationThumb';
import RESTApiIntegration from './RESTApi/RESTApiIntegration';
import RESTApiIntegrationThumb from './RESTApi/RESTApiIntegrationThumb';
import { changeTabs } from '../../../../../redux/actions';
import SHRCRSIntegration from './SHRCRS/SHRCRSIntegration';
import SHRCRSIntegrationThumb from './SHRCRS/SHRCRSIntegrationThumb';

import RMSIntegrationThumb from './RMSIntegrationThumb';
import MewsIntegration from './Mews/MewsIntegration';
import MewsIntegrationThumb from './Mews/MewsIntegrationThumb';
import SabreIntegration from './Sabre/SabreIntegration';
import SabreIntegrationThumb from './Sabre/SabreIntegrationThumb';
import Sabre_Logo from '../../../../../assets/aven_short.png';
import AmazonIntegration from './Amazon/AmazonIntegration';
import AmazonIntegrationThumb from './Amazon/AmazonIntegrationThumb';
import AzureIntegration from './Azure/AzureIntegration';
import AzureIntegrationThumb from './Azure/AzureIntegrationThumb';
import Amazon_logo from '../../../../../assets/Amazon_logo.png';
import OneNZ_logo from '../../../../../assets/onenz.png';
import Farehourbor_logo from '../../../../../assets/farehourbor.png';
import Rezdy_logo from '../../../../../assets/rezdy-logo.svg';
import Ways_logo from '../../../../../assets/ways.svg';
import OneNZIntegration from './OneNZ/OneNZIntegration';
import OneNZIntegrationThumb from './OneNZ/OneNZIntegrationThumb';
import FarehourborIntegration from './Farehourbor/FarehourborIntegration';
import FarehourborIntegrationThumb from './Farehourbor/FarehourborIntegrationThumb';
import RezdyIntegration from './Rezdy/RezdyIntegration';
import RezdyIntegrationThumb from './Rezdy/RezdyIntegrationThumb';
import WaysIntegration from './Way_IO/WaysIntegration';
import WaysIntegrationThumb from './Way_IO/WaysIntegrationThumb';

function Application({
  match,
  propertyId,
  email,
  isVoucherEngine,
  changeTabs,
  domains,
  locale,
  integrationTab,
  serviceProvider,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [integrations, setIntegrations] = useState([]);

  const [stripeIntregation, setStripeIntregations] = useState([]);

  const [revinateintegrations, setRevinateIntegrations] = useState([]);
  const [amadeusIntegration, setAmadeusIntegration] = useState([]);
  const [bookingEngineUrlIntegration, setBookingEngineUrlIntegration] =
    useState([]);
  const [standalonePageIntegration, setStandalonePageIntegration] = useState(
    []
  );
  const [selectedTab, setSelectedTab] = useState('Installed Apps');
  const [activeTab, setActiveTab] = useState('standard');
  const [webRTCIntegrations, setWebRTCIntegrations] = useState([]);
  const [embedPageIntegration, setEmbedPageIntegration] = useState([]);
  const [phoneSuiteIntegrations, setPhoneSuiteIntegrations] = useState([]);
  const [
    standaloneGuestServicePageIntegration,
    setStandaloneGuestServicePageIntegration,
  ] = useState([]);
  //disable channel
  const [disableApplicationsList, setdisableApplicationsList] = useState([]);

  const [oracleOperaIntegration, setOracleOperaIntegration] = useState([]);
  const [helpCenterIntegration, setHelpCenterIntegration] = useState([]);
  const [helpCenterGroupIntegration, setHelpCenterGroupIntegration] = useState(
    []
  );
  const [emailIntegration, setEmailIntegration] = useState([]);

  const [allProperties, setAllProperties] = useState([]);
  const [rmsBookingEngineData, setRMSBookingEngineList] = useState([]);
  const [isAdd, setIsAdd] = useState(false);

  const [isAddPhone, setIsAddPhone] = useState(false);
  const [isAddRevinate, setIsAddRevinate] = useState(false);

  const [isAddGb, setIsAddGb] = useState(false);

  const [isWebRTCIntegration, setIsWebRTCIntegration] = useState(false);
  const [isAddPhoneSuite, setIsPhoneSuite] = useState(false);
  const [isGoogleAnalyticsAvailable, setIsGoogleAnalyticsAvailable] =
    useState(false);

  const [messageVisible, setmessageVisible] = useState(
    localStorage.getItem('ShowMessage')
      ? localStorage.getItem('ShowMessage')
      : false
  );
  const [cloudBedsVisible, setCloudsBedsVisible] = useState(
    localStorage.getItem('ShowCloudbedsMessage')
      ? localStorage.getItem('ShowCloudbedsMessage')
      : false
  );

  const [instagramVisible, setInstagramVisible] = useState(
    localStorage.getItem('ShowInstagramMessage')
      ? localStorage.getItem('ShowInstagramMessage')
      : false
  );

  const [confirmMessage, setConfirmMeesage] = useState(
    localStorage.getItem('ShowConfirm')
      ? localStorage.getItem('ShowConfirm')
      : false
  );

  const [paymentmodelvisible, setpaymentmodelvisible] = useState(false);
  const [createaccountModel, setcreateaccountModel] = useState(false);
  const [isConnected, setisConnected] = useState(false);
  const [stripeIntegrationId, setStripeIntegrationId] = useState('');
  const [stripepropertyId, setStripeProprtyId] = useState('');
  const [isOneNZIntegration, setIsOneNZInetgration] = useState(false);
  const [isAddRms, setIsAddRms] = useState(false);
  const [isAddSiteminder, setIsSiteminderb] = useState(false);
  const [isFarehourbor, setIsFarehourbor] = useState(false);
  const [isAddAmadeus, setIsAmadeus] = useState(false);
  const [isAddBookingEngine, setIsAddBookingEngine] = useState(false);
  const [isAddStandalonePage, setIsAddStandalonePage] = useState(false);
  const [isAddEmbedPage, setIsAddEmbedPage] = useState(false);
  const [isAddStandaloneGuestServicePage, setIsAddStandaloneGuestServicePage] =
    useState(false);
  const [isSalesforce, setIsSalesforce] = useState(false);

  const [isAddOracleOpera, setIsAddOracleOpera] = useState(false);
  const [isAddHelpCenter, setIsAddHelpCenter] = useState(false);
  const [isAddHelpCenterGroup, setIsAddHelpCenterGroup] = useState(false);
  const [isRezdy, setIsRezdy] = useState(false);
  const [isWays, setIsWays] = useState(false);
  const [salesforceIntegration, setSalesforceIntegration] = useState([]);
  const [warningMsgVisible, setWarningMsgVisible] = useState(false);
  const [cloudBeds, setCloudsBeds] = useState([]);
  const [farehourborList, setFarehourborList] = useState(false);
  const [googleAnalytics, setGoogleAnalytics] = useState([]);
  const [isGoogleAnalytics, setIsGoogleAnalytics] = useState(false);
  const [spaceStandAloneList, setSpaceStandAloneList] = useState([]);
  const [isSpaceStandalonePage, setIsSpaceStandAlonePage] = useState(false);

  const [sabreIntegrationList, setSabreIntegrationList] = useState([]);
  const [isSabreIntegrationPage, setIsSabreIntegrationPage] = useState(false);

  const [restApiIntegrationList, setRESTApiIntegrationList] = useState([]);
  const [isRESTApiIntegrationPage, setIsRESTApiIntegrationPage] =
    useState(false);
  const [isAddMews, setIsAddMews] = useState(false);
  const [mewsIntegrationList, setMewsIntegrationList] = useState([]);
  const [isAddSHR, setIsAddSHR] = useState(false);
  const [shrCRSIntegrationList, setSHRCRSIntegrationList] = useState();
  const [isAddAmazon, setIsAddAmazon] = useState(false);
  const [amazonIntegration, setAmazonIntegration] = useState([]);
  const [oneNZInetgrationList, setOneNZIntegrationList] = useState([]);
  const [rezdyList, setRezdyList] = useState([]);
  const [waysList, setWaysList] = useState([]);
  const [isDynamic, setIsDynamic] = useState(false);

  const [isAddAzure, setIsAddAzure] = useState(false);
  const [azureIntegration, setAzureIntegration] = useState([]);

  const handleProerptyId = (id) => {
    setStripeProprtyId(id);
  };
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
      // setIsLoading(false);
    });
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Integrations',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => { }
      );
    }
    // Fetch property details by ID
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        const data = res.data;
        console.log(1234, data);
        setIsDynamic(data.isVirtualFrontDesk || false);
      })
      .catch((err) => console.error(err));
  }, [propertyId]);

  const checkConnection = () => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/check`,
      data,
    })
      .then((m) => {
        if (m.data.stripeCustomerId == '') {
        }
        setStripeIntegrationId(m.data.stripeCustomerId);
      })
      .catch((err) => { });
  };
  const RefreshConnection = (status, id) => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      Creator: 'Admin',
      StripeCustomerId: status === 'Archieve' ? '' : stripeIntegrationId,
      StripeStatus: status,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/save`,
      data: data,
    })
      .then((res) => {
        if (status === 'Archieve') {
          AxiosAPI({
            method: 'delete',
            url: `${gAPI_Stripe_Connection}/remove?id=${id}`,
            data: data,
          })
            .then((res) => { })
            .catch((err) => { });
        }
      })
      .catch((err) => { });
  };
  const handlePayment = () => {
    var restUrl = window.location.href.substring(
      0,
      window.location.href.lastIndexOf('/') + 1
    );
  };
  const handleTabs = (tabs) => {
    changeTabs(tabs);
    setSelectedTab(tabs);
  };

  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    checkConnection();
  }, []);
  const LoadIntegrations = () => {
    setIsLoading(true);
    let body = {
      channels: [
        'WebsiteDirectLine',
        'RMSBookingEngine',
        'FacebookDirectLine',
        'Phone',
        'GoogleBusinessMessage',
        'Revinate',
        'RESTAPI',
        'WeChat',
        'SHRCRS',
        'Amadues',
        'BookingEngineUrl',
        'ServiceStandAlonePage',
        'EmbedService',
        'Salesforce',
        'GuestServiceStandAlonePage',
        'WhatsApp',
        'OracleOpera',
        'HelpCenter',
        'Sabre',
        'InstagramDirectLine',
        'SHRCRS',
        'CloudBeds',
        'Mews',
        'GoogleAnalytics',
        'HelpCenterGroup',
        'SpaceStandalone',
        'PhoneSuite',
        'WebRTC',
        'EmailDirectLine',
        'Amazon',
        'OneNZ',
        'Farehourbor',
        'Rezdy',
        'Ways',
        'Azure',
      ],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        // console.log(res.data);

        filteringIntegrations(integrations);

        const shrCRSIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'SHRCRS')
        );
        const webIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'WebsiteDirectLine')
        );

        const revinateIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Revinate')
        );

        const amadeusIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Amadues')
        );
        const bookingEngineUrlIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'BookingEngineUrl')
        );
        const standalonePageIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'ServiceStandAlonePage')
        );
        const embedPageIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'EmbedService')
        );
        const salesforceIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Salesforce')
        );
        const standaloneGuestServicePageData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'GuestServiceStandAlonePage')
        );

        const oracleOperaIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'OracleOpera')
        );
        const helpCenterIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'HelpCenter')
        );
        const cloudsBedsIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'CloudBeds')
        );
        const googleAnalyticsInegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'GoogleAnalytics')
        );
        const helpCenterGroupIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'HelpCenterGroup')
        );
        const spaceStandAloneIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'SpaceStandalone')
        );
        const phoneSuiteIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'PhoneSuite')
        );

        const webRTCIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'WebRTC')
        );

        const restAPIIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'RESTAPI')
        );

        const rmsBookingData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'RMSBookingEngine')
        );

        const mewsIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Mews')
        );

        const sabreIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Sabre')
        );

        const emailIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'EmailDirectLine')
        );
        const amazonIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Amazon')
        );
        const onenzIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'OneNZ')
        );
        const farehourborIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Farehourbor')
        );
        const rezdyIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Rezdy')
        );
        const waysIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Ways')
        );
        const azureIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Azure')
        );
        setFarehourborList(farehourborIntegrationData);
        setEmailIntegration(emailIntegrationData);
        setSabreIntegrationList(sabreIntegrationData);
        setMewsIntegrationList(mewsIntegrationData);
        setRMSBookingEngineList(rmsBookingData);
        setRESTApiIntegrationList(restAPIIntegrationData);
        setSHRCRSIntegrationList(shrCRSIntegration);
        setWebRTCIntegrations(webRTCIntegrationData);

        setPhoneSuiteIntegrations(phoneSuiteIntegrationData);
        // console.log(spaceStandAloneIntegrationData);
        setSpaceStandAloneList(spaceStandAloneIntegrationData);
        setGoogleAnalytics(googleAnalyticsInegration);
        setCloudsBeds(cloudsBedsIntegration);
        // console.log(salesforceIntegrationData);
        setSalesforceIntegration(salesforceIntegrationData);
        setIntegrations(webIntegrationData);

        setRevinateIntegrations(revinateIntegrationData);

        setStripeIntregations([]);

        setAmadeusIntegration(amadeusIntegration);
        setBookingEngineUrlIntegration(bookingEngineUrlIntegrationData);
        setStandalonePageIntegration(standalonePageIntegration);
        setEmbedPageIntegration(embedPageIntegration);
        setStandaloneGuestServicePageIntegration(
          standaloneGuestServicePageData
        );
        setOneNZIntegrationList(onenzIntegrationData);
        setOracleOperaIntegration(oracleOperaIntegrationData);
        setHelpCenterIntegration(helpCenterIntegrationData);
        setHelpCenterGroupIntegration(helpCenterGroupIntegrationData);
        setAmazonIntegration(amazonIntegrationData);
        setAzureIntegration(azureIntegrationData);
        setRezdyList(rezdyIntegration);
        setWaysList(waysIntegration);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const filteringIntegrations = (integrations) => {
    if (Array.isArray(integrations)) {
      return integrations.filter((integration) => {
        if (
          disableApplicationsList?.length > 0 &&
          disableApplicationsList?.some(
            (channel) =>
              integration?.channel.toLowerCase() === channel.toLowerCase()
          )
        ) {
          return false;
        }
        return true;
      });
    }
    return integrations;
  };
  //filter available Apps
  const filterItem = (channelName) => {
    if (
      disableApplicationsList?.length > 0 &&
      disableApplicationsList?.some(
        (channel) => channelName.toLowerCase() === channel.toLowerCase()
      )
    ) {
      return false;
    }
    return true;
  };
  const fetchService = (serviceProvider) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Site_Settings}`,
    })
      .then((res) => {
        const matchedService = res.data.find(
          (item) => item.id.toString() === serviceProvider
        );
        if (matchedService) {
          const disableApplications = matchedService?.disableApplications || [];
          setdisableApplicationsList(disableApplications);
        } else {
          console.log(
            'No matched service found or disableApplications is empty'
          );
        }
      })
      .catch((err) => {
        console.error('Error fetching service provider:', err);
      });
  };

  useEffect(() => {
    LoadIntegrations();
  }, [disableApplicationsList]);

  useEffect(() => {
    fetchService(serviceProvider);
  }, [serviceProvider]);

  const handleDelete = (id) => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${id}/?group_id=${getGroupID()}`,
    }).then((res) => {
      LoadIntegrations();
    });
  };

  const toggleWarning = () => {
    setWarningMsgVisible(!warningMsgVisible);
  };
  //console.log(getGroupID());
  return (
    <Fragment>
      <CardHeader className="mb-2">
        <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
          <NavItem
            className=" text-center"
            style={{ width: 'auto', background: '' }}
          >
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'Available Apps',
                'nav-link': true,
              })}
              onClick={() => {
                handleTabs('Available Apps');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${selectedTab === 'Available Apps'
                    ? 'var(--theme-color-1)'
                    : '#8f8f8f'
                    }`,
                }}
              >
                Available Apps
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'Installed Apps',
                'nav-link': true,
              })}
              onClick={() => {
                handleTabs('Installed Apps');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${selectedTab === 'Installed Apps'
                    ? 'var(--theme-color-1)'
                    : '#8f8f8f'
                    } `,
                }}
              >
                Installed Apps
              </span>
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>

      <Fragment>
        <TabContent activeTab={selectedTab} className="">
          <TabPane
            tabId="Available Apps"
            className="chat-app-tab-pane"
            style={{ background: 'none' }}
          >
            {isRESTApiIntegrationPage ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <RESTApiIntegration
                        LoadIntegrations={LoadIntegrations}
                        visible={isRESTApiIntegrationPage}
                        toggle={() => {
                          setIsRESTApiIntegrationPage(
                            !isRESTApiIntegrationPage
                          );
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isOneNZIntegration ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <OneNZIntegration
                        LoadIntegrations={LoadIntegrations}
                        visible={isOneNZIntegration}
                        toggle={() => {
                          setIsOneNZInetgration(!isOneNZIntegration);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}{' '}
            {isFarehourbor ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <FarehourborIntegration
                        LoadIntegrations={LoadIntegrations}
                        visible={isFarehourbor}
                        toggle={() => {
                          setIsFarehourbor(!isFarehourbor);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isSabreIntegrationPage ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <SabreIntegration
                        visible={isSabreIntegrationPage}
                        propertyId={propertyId}
                        toggle={() => {
                          setIsSabreIntegrationPage(!isSabreIntegrationPage);
                        }}
                        LoadIntegrations={LoadIntegrations}
                        allProperties={allProperties}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddMews ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <MewsIntegration
                        LoadIntegrations={LoadIntegrations}
                        visible={isAddMews}
                        toggle={() => {
                          setIsAddMews(!isAddMews);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddStandalonePage ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AddServiceStandalonePageIntegration
                        visible={isAddStandalonePage}
                        LoadIntegrations={LoadIntegrations}
                        toggle={() => {
                          setIsAddStandalonePage(!isAddStandalonePage);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isSpaceStandalonePage ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AddSpaceStandAlonePageIntegration
                        visible={isSpaceStandalonePage}
                        propertyId={propertyId}
                        toggle={() => {
                          setIsSpaceStandAlonePage(!isSpaceStandalonePage);
                        }}
                        LoadIntegrations={LoadIntegrations}
                        allProperties={allProperties}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddPhone ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <PhoneIntegration
                        visible={isAddPhone}
                        toggle={() => {
                          setIsAddPhone(!isAddPhone);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddGb ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <GoogleBuisnessIntegration
                        visible={isAddGb}
                        toggle={() => {
                          setIsAddGb(!isAddGb);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddRms ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <RMSIntegration
                        visible={isAddRms}
                        toggle={() => {
                          setIsAddRms(!isAddRms);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddSiteminder ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <SiteminderIntegration
                        visible={isAddSiteminder}
                        toggle={() => {
                          setIsSiteminderb(!isAddSiteminder);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddRevinate ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <RevinateIntegration
                        visible={isAddRevinate}
                        toggle={() => {
                          setIsAddRevinate(!isAddRevinate);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isSalesforce ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <SalesforceIntegration
                        visible={isSalesforce}
                        toggle={() => {
                          setIsSalesforce(!isSalesforce);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isWebRTCIntegration ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <WebRTCIntegration
                        visible={isWebRTCIntegration}
                        toggle={() => {
                          setIsWebRTCIntegration(!isWebRTCIntegration);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddAmadeus ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AmadeusIntegration
                        visible={isAddAmadeus}
                        toggle={() => {
                          setIsAmadeus(!isAddAmadeus);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddSHR ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <SHRCRSIntegration
                        visible={isAddSHR}
                        LoadIntegrations={LoadIntegrations}
                        toggle={() => {
                          setIsAddSHR(!isAddSHR);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddPhoneSuite ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <PhoneSuiteIntegration
                        visible={isAddPhoneSuite}
                        LoadIntegrations={LoadIntegrations}
                        toggle={() => {
                          setIsPhoneSuite(!isAddPhoneSuite);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddBookingEngine ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <BookingEngineUrlIntegration
                        visible={isAddBookingEngine}
                        toggle={() => {
                          setIsAddBookingEngine(!isAddBookingEngine);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddEmbedPage ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AddEmbedPageIntegration
                        visible={isAddEmbedPage}
                        LoadIntegrations={LoadIntegrations}
                        toggle={() => {
                          setIsAddEmbedPage(!isAddEmbedPage);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddStandaloneGuestServicePage ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AddStandaloneGuestServicePageIntegration
                        visible={isAddStandaloneGuestServicePage}
                        LoadIntegrations={LoadIntegrations}
                        toggle={() => {
                          setIsAddStandaloneGuestServicePage(
                            !isAddStandaloneGuestServicePage
                          );
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddOracleOpera ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <OracleOperaIntegration
                        visible={isAddOracleOpera}
                        toggle={() => {
                          setIsAddOracleOpera(!isAddOracleOpera);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddHelpCenter ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AddHelpCenterIntegration
                        visible={isAddHelpCenter}
                        toggle={() => {
                          setIsAddHelpCenter(!isAddHelpCenter);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddHelpCenterGroup ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AddHelpCenterGroupIntegration
                        visible={isAddHelpCenterGroup}
                        toggle={() => {
                          setIsAddHelpCenterGroup(!isAddHelpCenterGroup);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isGoogleAnalytics ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <GoogleAnalyticsIntegration
                        visible={isGoogleAnalytics}
                        toggle={() => {
                          setIsGoogleAnalytics(!isGoogleAnalytics);
                        }}
                        serviceProvider={serviceProvider}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddAmazon ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AmazonIntegration
                        visible={isAddAmazon}
                        toggle={() => {
                          setIsAddAmazon(!isAddAmazon);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isRezdy ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <RezdyIntegration
                        LoadIntegrations={LoadIntegrations}
                        visible={isRezdy}
                        toggle={() => {
                          setIsRezdy(!isRezdy);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isWays ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <WaysIntegration
                        LoadIntegrations={LoadIntegrations}
                        visible={isWays}
                        toggle={() => {
                          setIsWays(!isWays);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            {isAddAzure ? (
              <Row>
                <Colxx xxs="12">
                  <Row>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12">
                      <AzureIntegration
                        visible={isAddAzure}
                        toggle={() => {
                          setIsAddAzure(!isAddAzure);
                        }}
                      />
                    </Colxx>
                    <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  </Row>
                </Colxx>
              </Row>
            ) : null}
            <Row className="m-2 my-3">
              <Fragment>
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('ServiceStandAlonePage') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-2">
                                <img
                                  src={Myma_Logo}
                                  style={{ width: '7rem' }}
                                ></img>
                              </div>
                              {!isDynamic ? (
                                <Button size="xs" color="outline-grey">
                                  <span>Not Available</span>
                                </Button>
                              ) : (
                                <Button
                                  size="xs"
                                  color="primary"
                                  outline
                                  onClick={() =>
                                    setIsAddStandalonePage(!isAddStandalonePage)
                                  }
                                >
                                  <IntlMessages id="dashboards.connect" />
                                </Button>
                              )}
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Digital Compendium</h2>
                                  <span>
                                    Provide instant information to your in-house
                                    guests in tap of a button, or scan of a QR
                                    code.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('SpaceStandalone') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-2">
                                <img
                                  src={Myma_Logo}
                                  style={{ width: '7rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsSpaceStandAlonePage(
                                    !isSpaceStandalonePage
                                  )
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Space Booking Engine (Beta)</h2>
                                  <span>
                                    Showcase spaces like meeting rooms with
                                    inventory, availability, and rates.
                                    Streamline booking with only three clicks.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('BookingEngineUrl') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-2">
                                <img
                                  src={BookingEngine}
                                  style={{ width: '7rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => {
                                  bookingEngineUrlIntegration &&
                                    bookingEngineUrlIntegration.length === 0
                                    ? (window.location.href =
                                      '/app/pages/booking-engine-url')
                                    : toggleWarning();
                                }}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Booking Engine</h2>
                                  <span>
                                    Seamlessly send leads from messaging
                                    channels to the property booking engine.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('GoogleAnalytics') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-2">
                                <img
                                  src={Analytics_Logo}
                                  style={{ width: '3rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => {
                                  if (googleAnalytics.length > 0)
                                    setIsGoogleAnalyticsAvailable(
                                      !isGoogleAnalyticsAvailable
                                    );
                                  else setIsGoogleAnalytics(!isGoogleAnalytics);
                                }}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Google Analytics</h2>
                                  <span>
                                    Append all URLs referred by the chatbot with
                                    Google UTM tags for enhanced analytics in
                                    website GA.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Amadues') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={AmadeusLogo}
                                  style={{ width: '5.8rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAmadeus(!isAddAmadeus)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Amadeus</h2>
                                  <span>
                                    Show availability and rates within a
                                    conversation, and track conversion in
                                    Amadeus.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('OracleOpera') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-3">
                                <img
                                  src={Oracle_logo}
                                  style={{ width: '3rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsAddOracleOpera(!isAddOracleOpera)
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '1.5rem' }}
                              >
                                <div className="text-left">
                                  <h2>Oracle Opera Cloud</h2>
                                  <span>
                                    Provide 24/7 pre-checkin engagement. Message
                                    your guests before their arrival, with
                                    information, guidance, and personalised
                                    upsell options.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('RMSBookingEngine') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={RMSLogo}
                                  style={{ width: '2rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAddRms(!isAddRms)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>RMS Booking Engine</h2>
                                  <span>
                                    Show the AI Chatbot Web Widget inside the
                                    RMS Booking Engine.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('SiteMinder') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={SiteMinderLogo}
                                  style={{ width: '1.5rem' }}
                                ></img>
                              </div>
                              <a
                                href="https://help.myma.ai/en/articles/8204057-siteminder-booking-engine-integration"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <Button
                                  size="xs"
                                  color="primary"
                                  outline
                                // onClick={() => setIsSiteminderb(!isAddSiteminder)}
                                >
                                  <IntlMessages id="dashboards.connect" />
                                </Button>
                              </a>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Connect to SiteMinder</h2>
                                  <span>
                                    Make AI Chatbot Web Widget available within
                                    SiteMinder's Booking Engine Pages.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length === 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Revinate') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={RevinateLogo}
                                  style={{ width: '5.9rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAddRevinate(!isAddRevinate)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Revinate</h2>
                                  <span>
                                    Sync contact information with Revinate in
                                    realtime.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Salesforce') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel ml-2">
                                <FontAwesomeIcon
                                  icon={faSalesforce}
                                  style={{ fontSize: '3.5rem' }}
                                ></FontAwesomeIcon>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsWebRTCIntegration(!isWebRTCIntegration)
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Salesforce</h2>
                                  <span>
                                    Sync contact information with Salesforce in
                                    realtime.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Zendesk') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4">
                                <img
                                  src={Zendesk_logo}
                                  style={{ width: '3rem' }}
                                />
                              </div>
                              <div
                                className="btn-xs"
                                style={{
                                  color: 'var(--theme-color-1)',
                                  borderRadius: '50px',
                                  border: '1px solid var(--theme-color-1)',
                                }}
                              >
                                Enable in Chatbot
                              </div>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Zendesk</h2>
                                  <span>
                                    Seamless handoff to Zendesk agents when a
                                    human touch is necessary, flagging agents
                                    when to step in.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('WebRTC') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-3">
                                <img
                                  src={WebRTC_logo}
                                  style={{ width: '8rem' }}
                                />
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsWebRTCIntegration(!isSalesforce)
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>WebRTC for web calling</h2>
                                  <span>
                                    Enable voice calling for your agents and
                                    customers from Agent Assist and Digital
                                    Compendium.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('RESTAPI') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-3">
                                <img
                                  src={RestApiLogo}
                                  style={{ width: '3rem' }}
                                />
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsRESTApiIntegrationPage(
                                    !isRESTApiIntegrationPage
                                  )
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>External Rest API’s</h2>
                                  <span>
                                    Integrate to any external API to post or get
                                    the data
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('SHRCRS') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={SHR_Logo}
                                  style={{ width: '5.8rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAddSHR(!isAddSHR)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>SHR CRS</h2>
                                  <span>
                                    Show availability and rates within a
                                    conversation, and track conversion in SHR.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('CloudBeds') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={Genesys_Cloud_Logo}
                                  style={{ width: '8.8rem' }}
                                ></img>
                              </div>
                              <Button size="xs" color="primary" outline>
                                Enable in Chatbot
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Genesys PureCloud</h2>
                                  <span>
                                    Seamless handoff to Genesys PureCloud agents
                                    when a human touch is necessary, flagging
                                    agents when to step in.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Mews') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={Mews_Logo}
                                  style={{ width: '5.8rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAddMews(!isAddMews)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Mews Operations</h2>
                                  <span>
                                    Seamless handoff to customer messaging
                                    system of Mews when a human touch is
                                    necessary, alerting staff when to step in.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('SaltosOnlineLocks') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img
                                  src={FlexiPass}
                                  style={{ width: '6.8rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  window.open(
                                    'https://www.myma.ai/contact',
                                    '_blank'
                                  )
                                }
                              >
                                Contact Us
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Saltos Online Locks</h2>
                                  <span>
                                    In partnership with FLEXIPASS deliver
                                    WebKeys experience to open door from Digital
                                    Compendium.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Sabre') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-1 ml-2 mb-2">
                                <img
                                  src={Sabre_Logo}
                                  style={{ width: '3rem' }}
                                ></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsSabreIntegrationPage(
                                    !isSabreIntegrationPage
                                  )
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Aven Hospitality SynXis CRS</h2>
                                  <span>
                                    Sync hotel description and ARI from Aven Hospitality SynXis CRS
                                    so AI has the most up-to-date information to
                                    assist users.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Amazon') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img src={Amazon_logo} width="60px"></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAddAmazon(!isAddAmazon)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Amazon Connect</h2>
                                  <span>
                                    Seamless handoff to Amazon Connect agents
                                    when a human touch is necessary, flagging
                                    agents when to step in.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('OneNZ') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel mt-4 ml-2">
                                <img src={OneNZ_logo} width="30px"></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() =>
                                  setIsOneNZInetgration(!isOneNZIntegration)
                                }
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>SMS New Zealand</h2>
                                  <span>
                                    Send SMS API is to send text messages on
                                    mobile phones
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}

                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Farehourbor') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel my-2 ml-2 ">
                                <img src={Farehourbor_logo} width="45px"></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsFarehourbor(!isFarehourbor)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2> FareHarbor</h2>
                                  <span>
                                    Sync item descriptions from FareHarbor so AI
                                    has the most up-to-date information to
                                    assist users.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Rezdy') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel my-2 ml-2 ">
                                <img src={Rezdy_logo} width="70px"></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsRezdy(!isRezdy)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2> Rezdy</h2>
                                  <span>
                                    Sync item descriptions from Rezdy so AI has
                                    the most up-to-date information to assist
                                    users.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Ways') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel my-2 ml-2 ">
                                <img src={Ways_logo} width="100px"></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsWays(!isWays)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2> Way</h2>
                                  <span>
                                    Sync item descriptions from Way so AI has
                                    the most up-to-date information to assist
                                    users.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
                {isVoucherEngine && domains.length == 1 ? (
                  ''
                ) : (
                  <>
                    {filterItem('Azure') && (
                      <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                        <Card
                          className="d-flex flex-row integrationcard"
                          style={{ height: '215px' }}
                        >
                          <CardBody className="mt-0">
                            <div className="connect-title">
                              <div className="integrationChannel my-2 ml-2 ">
                                <img src={Azure_logo} width="45px"></img>
                              </div>
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => setIsAddAzure(!isAddAzure)}
                              >
                                <IntlMessages id="dashboards.connect" />
                              </Button>
                            </div>
                            <Row>
                              <Colxx
                                xxs="12"
                                className="mb-5"
                                style={{ marginTop: '2rem' }}
                              >
                                <div className="text-left">
                                  <h2>Azure</h2>
                                  <span>
                                    Connect to Azure to allow your chat bot for
                                    your users only or allow users to login via
                                    Azure only for dashboard access.
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          </CardBody>
                        </Card>
                      </Colxx>
                    )}
                  </>
                )}
              </Fragment>
            </Row>
          </TabPane>
          <TabPane
            tabId="Installed Apps"
            className="chat-app-tab-pane"
            style={{ background: 'none' }}
          >
            <Row className="m-2 my-3">
              {isLoading ? (
                <div className="text-center loading" />
              ) : (
                <Fragment>
                  {standalonePageIntegration &&
                    (!isVoucherEngine || domains.length > 1)
                    ? standalonePageIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <StandalonePageIntregationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {salesforceIntegration
                    ? salesforceIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <SalesforceIntegrationThumb
                            integration={integration}
                            // propertyId={propertyId}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}

                  {revinateintegrations &&
                    (!isVoucherEngine || domains.length > 1)
                    ? revinateintegrations.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <RevinateIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}

                  {amadeusIntegration &&
                    (!isVoucherEngine || domains.length > 1)
                    ? amadeusIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <AmadeusIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {bookingEngineUrlIntegration &&
                    (!isVoucherEngine || domains.length > 1)
                    ? bookingEngineUrlIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <BookingEngineUrlIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}

                  {spaceStandAloneList
                    ? spaceStandAloneList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <SpaceStandalonePageIntregationThumb
                            integration={integration}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}

                  {restApiIntegrationList
                    ? restApiIntegrationList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <RESTApiIntegrationThumb
                            integration={integration}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {googleAnalytics
                    ? googleAnalytics.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <GoogleAnalyticsThumb
                            integration={integration}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                            serviceProvider={serviceProvider}
                          />
                        </Fragment>
                      );
                    })
                    : null}

                  {oracleOperaIntegration &&
                    (!isVoucherEngine || domains.length > 1)
                    ? oracleOperaIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <OracleOperaIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {rmsBookingEngineData &&
                    (!isVoucherEngine || domains.length > 1)
                    ? rmsBookingEngineData.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <RMSIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {webRTCIntegrations &&
                    (!isVoucherEngine || domains.length > 1)
                    ? webRTCIntegrations.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <WebRTCIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {shrCRSIntegrationList &&
                    (!isVoucherEngine || domains.length > 1)
                    ? shrCRSIntegrationList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <SHRCRSIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {mewsIntegrationList &&
                    (!isVoucherEngine || domains.length > 1)
                    ? mewsIntegrationList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <MewsIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {sabreIntegrationList &&
                    (!isVoucherEngine || domains.length > 1)
                    ? sabreIntegrationList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <SabreIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {amazonIntegration && (!isVoucherEngine || domains.length > 1)
                    ? amazonIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <AmazonIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}

                  {oneNZInetgrationList &&
                    (!isVoucherEngine || domains.length > 1)
                    ? oneNZInetgrationList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <OneNZIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {farehourborList && (!isVoucherEngine || domains.length > 1)
                    ? farehourborList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <FarehourborIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {rezdyList && (!isVoucherEngine || domains.length > 1)
                    ? rezdyList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <RezdyIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {waysList && (!isVoucherEngine || domains.length > 1)
                    ? waysList.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <WaysIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                  {azureIntegration && (!isVoucherEngine || domains.length > 1)
                    ? azureIntegration.map((integration, index) => {
                      return (
                        <Fragment key={index}>
                          <AzureIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      );
                    })
                    : null}
                </Fragment>
              )}
            </Row>
          </TabPane>
        </TabContent>
      </Fragment>

      <StripeIntregation
        formLabel="Payment Methods in NewZeland"
        paymentmodelvisible={paymentmodelvisible}
        toggle={() => {
          setpaymentmodelvisible(!paymentmodelvisible);
        }}
        allProperties={allProperties}
        integration={stripeIntregation}
        LoadIntegrations={LoadIntegrations}
        refreshConnection={RefreshConnection}
        handleProerptyId={handleProerptyId}
        handlePayment={() => {
          checkConnection();
          setpaymentmodelvisible(!paymentmodelvisible);
          setcreateaccountModel(!createaccountModel);
        }}
      />
      <OpenAccount
        visible={createaccountModel}
        toggle={() => {
          setcreateaccountModel(!createaccountModel);
        }}
        createAccount={() => {
          handlePayment();
        }}
        deleteAccount={() => {
          stripeIntregation &&
            stripeIntregation.map((integration, index) => {
              handleDelete(integration.id);
              RefreshConnection(
                'Archieve',
                integration.channelDetails.stripeCustomerId
              );
            });
        }}
        isConnected={isConnected}
      />
      {messageVisible && (
        <ShowMessage
          formbody={'Connection established'}
          visible={messageVisible}
          isStripe={true}
          toggle={() => {
            localStorage.removeItem('ShowMessage');
            localStorage.removeItem('Message');
            setmessageVisible(!messageVisible);
          }}
        />
      )}
      {confirmMessage && (
        <ShowMessage
          formbody={'Connection established'}
          visible={confirmMessage}
          isStripe={false}
          toggle={() => {
            localStorage.removeItem('ShowConfirm');
            localStorage.removeItem('Message');
            setConfirmMeesage(!confirmMessage);
          }}
        />
      )}
      <ShowMessage
        formbody={'Connection established'}
        visible={cloudBedsVisible}
        logo={CloudBeds_Logo}
        toggle={() => {
          localStorage.removeItem('ShowCloudbedsMessage');
          setCloudsBedsVisible(!cloudBedsVisible);
        }}
      />

      <ShowMessage
        formbody={'You are already connected with Google Analytics.'}
        visible={isGoogleAnalyticsAvailable}
        logo={Analytics_Logo}
        toggle={() => {
          setIsGoogleAnalyticsAvailable(!isGoogleAnalyticsAvailable);
        }}
      />
      <ShowWarningMessage
        visible={warningMsgVisible}
        toggle={toggleWarning}
      ></ShowWarningMessage>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  let {
    propertyId,
    email,
    isVoucherEngine,
    domains,
    locale,
    integrationTab,
    serviceProvider,
  } = settings;
  return {
    propertyId,
    email,
    isVoucherEngine,
    domains,
    locale,
    integrationTab,
    serviceProvider,
  };
};

export default injectIntl(
  connect(mapStateToProps, { changeTabs })(Application)
);
